import "../css/footer.css";
import logoMelvin from "../img/LogoMelvin.png";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [t] = useTranslation("global");
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="ctnInfo col-md-5">
            <h3>{t("Profile.name")}</h3>
            <p>{t("Footer.descriptionFooter")}</p>
            <div className="logoMelvin">
              <img loading="lazy" src={logoMelvin} alt="logo" />
            </div>
          </div>
        </div>
        <p className="copyright">{"© " + currentYear + t("Footer.allRigth")}</p>
      </div>
    </footer>
  );
};
export default Footer;
